module.exports = __webpack_public_path__ + "files/8acbf1fd223b262afb16b48dcf27abb9.png";